import axios from 'axios';
import * as Sentry from '@sentry/react';

export const getPacket = id =>
	axios
		.get(`/forms_rest_api/packet/${id}`)
		.then(response => response.data)
		.catch(error => {
			Sentry.captureException(error);
			throw new Error('Failed to load packets');
		});

// Gets all packets on clicking project phase, loads all packets in packetsList
export const getPackets = (projectNumber = '', phaseNumber = '', page = 0) =>
	axios
		.get(
			`/jsonapi/node/packet?include=field_packet_forms,field_packet_attachments&${
				projectNumber && phaseNumber
					? `filter[field_packet_project_phase.field_pp_project_number][value]=${projectNumber}&filter[field_packet_project_phase.field_pp_phase][value]=${phaseNumber}&page[offset]=${
							page * 50
						}&sort=-created`
					: 'filter[field_packet_unassigned]=true&sort=-created'
			}`
		)
		.then(({ data }) =>
			data.data
				.map(packet => {
					const forms = packet.relationships.field_packet_forms.data.map(({ id }) => {
						const form = data.included.find(item => item.type === 'paragraph--form' && item.id === id);
						return {
							id: form.id,
							form_nid: form.attributes.drupal_internal__id,
							title: form.attributes.field_form_title,
							created: form.attributes.created,
							form_id: form.attributes.field_form_id,
							form_data: form.attributes.field_form_data,
							form_definition: form.attributes.field_form_definition
						};
					});

					let attachments = {
						photos: [],
						sketches: [],
						comments: []
					};

					packet.relationships.field_packet_attachments.data.forEach(async ({ id }) => {
						const attachment = data.included.find(
							item => item.type === 'paragraph--attachments' && item.id === id
						);

						const image =
							attachment.attributes.field_attachment_type === 'photos'
								? await axios
										.get(attachment.relationships.field_attachment_file.links.related.href)
										.then(({ data: _data }) =>
											axios
												.get(_data.data.relationships.field_image.links.related.href)
												.then(({ data: __data }) => __data.data.attributes.uri.url)
												.catch(Sentry.captureException)
										)
										.catch(Sentry.captureException)
								: attachment.attributes.field_attachment_sketch;

						attachments[attachment.attributes.field_attachment_type].push({
							comment: attachment.attributes.field_attachment_comment,
							creator: attachment.attributes.field_attachment_creator,
							nid: attachment.attributes.drupal_internal__id,
							type: attachment.attributes.field_attachment_type,
							created: Date.parse(attachment.attributes.created),
							formId: attachment.attributes.field_attachment_form_id || '',
							formTitle: attachment.attributes.field_form_title || '',
							image,
							id: attachment.id
						});
					});

					return {
						packet_nid: packet.attributes.drupal_internal__nid,
						packet_id: packet.id,
						title: packet.attributes.title,
						created: `${Math.floor(Date.parse(packet.attributes.created) / 1000)}`, // format to unix (secs) timestamp string
						changed: `${Math.floor(Date.parse(packet.attributes.changed) / 1000)}`, // format to unix (secs) timestamp string
						packet_forms: forms,
						packet_attachments: attachments,
						packet_tag: packet.attributes.field_packet_tag,
						created_by: packet.attributes.field_packet_created_by,
						submitted: packet.attributes.field_packet_submitted,
						unassigned: packet.attributes.field_packet_unassigned
					};
				})
				.sort((a, b) => b.created - a.created)
		)
		.catch(error => {
			Sentry.captureException(error);
			throw new Error('Failed to load packets');
		});
